import axios from '../api/index.js';

//查询字典列表
export let getDict = (params) => {
    return axios.post(`/dict/dict/${params}`);
};


// WEBPACK FOOTER //
// ./src/api/dict.js